const currentUser = state => state.login;

export {
   currentUser,
}
